import React, { useState, useEffect, useContext } from "react";
import * as StyleDOM from "../../../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateDocuments.jsx";
import Button from "../../../../Common/Button/Button";
import ContactCard from "../../../../Common/Contact-Card/ContactCard.js";
import AnimationPlayer from "../../../../Common/Animation-Player/AnimationPlayer";
import NoDataFoundAnimation from "../../../../Assets/Json/nodata-found-robot-animation.json";
import AddIcon from "../../../../Assets/Images/addIcon.png";
import GlobalSearchBox from "../../../../Common/GlobalSearchBox/GlobalSearchBox.js";
import ClientSearchDarkIcon from "../../../../Assets/Images/Clients Search Icon Dark.svg";
import ClientSearchLightIcon from "../../../../Assets/Images/Clients Search Icon Light.svg";
import rightArrowIcon from "../../../../Assets/Images/arrow-right.png";
import {
  VYLABS_BASE_URL,
  SEARCH_CLIENT_CONTACTS,
} from "../../../../helper/url_helper.js";
import { get } from "../../../../helper/Api_helper.js";
import staticData from "../../../../Assets/Json/StaticData.json";
import { Toast } from "../../../../Common/Toast-Snackbar/ToastSnackbar";
import { DynamicContext } from "../../../../Context/DynamicContext";

const ClientAdditionalContacts = ({
  contacts,
  onAddContact,
  onViewContact,
  onEditContact,
  onDeleteContact,
  isDarkMode,
  clientId,
}) => {
  const { isHiringTeamTenant } = useContext(DynamicContext);
  const tenantLabel = isHiringTeamTenant ? "Hiring Team" : "Client";
  const [searchQuery, setSearchQuery] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [filterKey, setFilterKey] = useState(null);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const { client_filter_options = {} } = staticData;
  const { clientConatctOptions = [] } = client_filter_options || {};

  useEffect(() => {
    setFilteredContacts(contacts);
  }, [contacts]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (value.length === 0) {
      setHasSearched(false);
      setFilteredContacts(contacts);
    }
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) {
      setHasSearched(false);
      setFilteredContacts(contacts);
      return;
    }
    const filterType = filterKey?.id || "name";
    setIsSearching(true);
    try {
      let url = `${SEARCH_CLIENT_CONTACTS}?client_id=${clientId}&limit=30&offset=0`;
      if (filterType === "name") {
        url += `&name=${encodeURIComponent(searchQuery.trim())}`;
      } else if (filterType === "email") {
        url += `&email=${encodeURIComponent(searchQuery.trim())}`;
      }

      const response = await get(VYLABS_BASE_URL, url);
      const searchResults = response?.contacts || [];
      setFilteredContacts(searchResults);
      setHasSearched(true);

      if (searchResults.length === 0) {
        Toast("info", "No contacts found matching your search");
      }
    } catch (error) {
      console.error("Search contacts error:", error);
      Toast("error", "Failed to search contacts. Please try again.");
      setFilteredContacts(contacts);
    } finally {
      setIsSearching(false);
    }
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setHasSearched(false);
    setFilterKey(null);
    setFilteredContacts(contacts);
  };

  const handleFilterClick = (option) => {
    setFilterKey(option);
  };

  const handleBackToContactList = () => {
    setSearchQuery("");
    setHasSearched(false);
    setFilterKey(null);
    setFilteredContacts(contacts);
  };

  const hasContacts = filteredContacts && filteredContacts.length > 0;

  return (
    <>
      {contacts.length > 0 && (
        <GlobalSearchBox
          isDarkMode={isDarkMode}
          titleIconLight={ClientSearchLightIcon}
          titleIconDark={ClientSearchDarkIcon}
          titleIconAlt="Contact Search"
          value={searchQuery}
          onChange={handleSearchChange}
          onSearch={handleSearch}
          suggestions={clientConatctOptions}
          showClearSearch={hasSearched}
          onClear={handleClearSearch}
          placeholder="Search contacts by name or email"
          subText=""
          searchTitle="Contact Person's Search"
          buttonLabel="Search"
          onFilterClick={handleFilterClick}
          askmeanythingOnKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSearch();
            }
          }}
          enableGlobalEnter={true}
          resetKey={0}
          resetSelectedSuggestion
        />
      )}
      <div className="contacts-tab-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "-15px",
            marginTop: "20px",
          }}
        >
          {contacts.length > 0 ? (
            <>
              <div
                className="contact-person-title"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                {hasSearched ? (
                  <Button
                    label="Back to Contact List"
                    event={handleBackToContactList}
                    iconSrc={rightArrowIcon}
                    className={`can-btn ${"active"}`}
                    style={{ marginBottom: "-10px" }}
                  />
                ) : (
                  <>
                    <span
                      style={{
                        color: "var(--header__color)",
                        fontSize: "20px",
                        fontWeight: "600",
                        lineHeight: "26px",
                      }}
                    >
                      Contact Person's List
                    </span>
                    <div
                      style={{
                        backgroundColor: "#6860EE",
                        color: "#FFFFFF",
                        borderRadius: "20px",
                        padding: "0px 12px",
                        fontSize: "14px",
                        fontWeight: "600",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "30px",
                        height: "28px",
                      }}
                    >
                      {filteredContacts.length}
                    </div>
                  </>
                )}
              </div>
              {hasSearched ? null : (
                <Button
                  label="Add Contact"
                  event={onAddContact}
                  iconSrc={AddIcon}
                  iconWidth="15px"
                  style={{ padding: "8px 15px" }}
                  backgroundColor="#6860EE"
                  color="#FFFFFF"
                  border="none"
                />
              )}
            </>
          ) : null}
        </div>
        <div className="contacts-list">
          {hasContacts ? (
            <ContactCard
              contacts={filteredContacts}
              onViewContact={onViewContact}
              onEditContact={onEditContact}
              onDeleteContact={onDeleteContact}
              title="Additional Contacts"
            />
          ) : (
            <div
              className="no-contacts-container"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px 20px",
                textAlign: "center",
              }}
            >
              <StyleDOM.HistoryInfoText className="history-info-text">
                {hasSearched
                  ? "There is no Contact person available for your search query"
                  : `No additional contacts have been added for this ${tenantLabel} yet. Add alternative contact persons who can be reached for this ${tenantLabel}.`}
              </StyleDOM.HistoryInfoText>
              <AnimationPlayer
                animationSrc={NoDataFoundAnimation}
                playerHeight="250px"
                playerWidth="300px"
              />
              {!hasSearched && (
                <Button
                  label="Add Contact"
                  event={onAddContact}
                  iconSrc={AddIcon}
                  iconWidth="15px"
                  style={{ padding: "8px 15px" }}
                  backgroundColor="#6860EE"
                  color="#FFFFFF"
                  border="none"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ClientAdditionalContacts;
